module.exports = __webpack_public_path__ + "static/cad-designs2-d639f4bf89bfd6c2fb3af358a5095f74.png";